import React, { useState } from 'react';
import { Button, Row, Col, Container } from 'react-bootstrap';
import NewBroadcast from './NewBroadcast';
import Broadcast from './Broadcast';

export const BroadcastManagement = () => {
  const [showAddForm, setShowAddForm] = useState(false);

  return (
    <Container fluid className="contact-management px-3 px-md-4 px-lg-5 py-4 container-fluid">
      <Row className="mb-2">
        <Col className="d-flex justify-content-end">
          <Button
            variant={showAddForm ? "outline-primary" : "primary"}
            onClick={() => setShowAddForm(!showAddForm)}
            className="px-4"
          >
            {showAddForm ? (
              <>
                <i className="mdi mdi-plus-circle-outline me-1"></i>Broadcast List

              </>
            ) : (
              <>
                <i className="mdi mdi-format-list-bulleted me-1"></i>Add Broadcast
              </>
            )}
          </Button>
        </Col>
      </Row>

      <Row>
        <Col>
          <div >
            {showAddForm ? (
              <NewBroadcast />

            ) : (
              <Broadcast />
            )}
          </div>
        </Col>
      </Row>
 </Container>
  );
};